import React, { useState } from "react";

import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Checkbox,
  Heading,
  HStack,
  IconButton,
  Link,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  Text
} from "@chakra-ui/react";

import { AiOutlineSend } from "react-icons/ai";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

interface EnterWhatsappNumberProps {
  phone: string;
  isForSelf: boolean;
  isSubmittingNumber: boolean;
  knowsWhatsappNumber: boolean;
  setPhone: (phone: string) => void;
  handleSubmitNumber: (e: React.FormEvent<HTMLFormElement>) => void;
  setKnowsWhatsappNumber: (knowsWhatsappNumber: boolean) => void;
}

export const EnterWhatsappNumber: React.FC<EnterWhatsappNumberProps> = ({
  phone,
  isForSelf,
  isSubmittingNumber,
  knowsWhatsappNumber,
  setPhone,
  handleSubmitNumber,
  setKnowsWhatsappNumber
}) => {
  const [hasAcceptedTerms, setHasAcceptedTerms] = useState(false);

  const isButtonDisabled = () => {
    if (!knowsWhatsappNumber) return false;
    if (!phone) return true;
    if (isForSelf && !hasAcceptedTerms) return true;
    return false;
  };

  return (
    <ModalContent
      onSubmit={handleSubmitNumber}
      rounded={16}
      as="form"
      fontWeight={500}
      p={12}
    >
      <ModalHeader p={0}>
        <Heading fontSize={20} color="secondary.600" fontWeight={600}>
          Connect WhatsApp Number
        </Heading>
      </ModalHeader>
      <ModalCloseButton top={10} right={10} />
      <ModalBody pt={10} px={0}>
        <Text>Enter WhatsApp number</Text>
        <HStack mt={1}>
          <PhoneInput
            country="gb"
            value={phone}
            onChange={setPhone}
            inputProps={{
              required: true
            }}
            preferredCountries={["gb", "us"]}
            buttonStyle={{
              backgroundColor: "white",
              margin: "6px 0px",
              border: 0,
              borderLeft: "1px solid lightgrey",
              borderRight: "1px solid lightgrey"
            }}
            inputStyle={{
              height: 46,
              width: "100%",
              fontFamily: "Montserrat"
            }}
            placeholder=" "
          />

          <IconButton
            h={46}
            fontSize={24}
            isDisabled={isButtonDisabled()}
            isLoading={isSubmittingNumber}
            w={88}
            aria-label="send"
            type="submit"
            icon={<AiOutlineSend />}
          />
        </HStack>

        {isForSelf ? (
          <Accordion mt={2} allowToggle>
            <AccordionItem border={0}>
              <h2>
                <AccordionButton px={0}>
                  <HStack
                    fontSize={12}
                    fontWeight={500}
                    as="span"
                    flex="1"
                    textAlign="left"
                  >
                    <Checkbox
                      size="sm"
                      colorScheme="primary"
                      isChecked={hasAcceptedTerms}
                      onChange={() => setHasAcceptedTerms(!hasAcceptedTerms)}
                    />
                    <Text>
                      Agree to our Terms & Conditions & Opt In. Click to See
                      T/Cs
                    </Text>
                  </HStack>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel fontSize={12} pb={4}>
                By opting into Jack&apos;s WhatsApp service, you agree to
                receive communication from Jenesys AI and the AI service known
                as Jack, solely for the purpose of sharing information, how-to
                instructions or required further detail regarding the sending or
                receiving of documents to or from the Jack WebApp platform.{" "}
                <br />
                <br /> Jenesys AI complies with all applicable laws and
                regulations which can be found at&nbsp;
                <Link
                  textDecor="underline"
                  isExternal
                  href="https://www.jenesys.co/legal"
                >
                  www.jenesys.co/legal
                </Link>
                <br />
                <br /> You may opt out at any time by disconnecting the service
                via the Jack WebApp.
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        ) : (
          <Checkbox
            mt={4}
            size="sm"
            colorScheme="primary"
            isChecked={!knowsWhatsappNumber}
            onChange={() => setKnowsWhatsappNumber(!knowsWhatsappNumber)}
          >
            I don&apos;t have user&apos;s WhatsApp number
          </Checkbox>
        )}
      </ModalBody>
    </ModalContent>
  );
};
